<template>
  <div class="news-list-ctner">
    <ul class="news-list">
      <li v-for="(item, idx) in formatedShowList"
          :key="idx">
        <router-link :to="{name: 'mNewsDetail', params: {id: item.id}}" >
          <div class="item-ctner">
            <h3 class="title-h3 tit-h3">
              {{item.title}}
            </h3>
            <time>{{item.gmtPublish}}</time>
            <div class="item-cover">
              <img :src="item.coverUrl" alt="" />
            </div>
          </div>
        </router-link>
      </li>
    </ul>
    <button class="more-news"
            ref="loadTag"
            v-show="hasMore">
      <em class="i-fresh"></em>上划查看更多
    </button>
    <button class="more-news"
            v-show="!hasMore">
      没有更多了
    </button>
  </div>
</template>

<script>
  import StickyBar from '../components/stickyBar.vue'
  import fetch from '../server/index'
  import Bus from '../assets/js/Bus'
  import ScrollLoad from '../components/scrollLoad.js';

  export default {
    data () {
      return {
        anchors: [{
          title: '一维新闻',
          name: 'News',
//          params: {type: 'bio'},
          icon: null
        }],
        hasMore: true,
        showList: [],
        page: 1,
        pageSize: 10,
        year: 0
      }
    },
    computed: {
      formatedShowList () {
        // eslint-disable-next-line
        let webReg = 'http';
        let format = this.showList.map(n => {
          if (n.coverUrl.indexOf(webReg) >= 0) {
            return n;
          }
          n.coverUrl = window.config.host + n.coverUrl
          return n;
        });

        return format;
      }
    },
    methods: {
//      获取资讯列表
      getList (year, append) {
        fetch('/api/policyInfo/list', {
          pageNumber: this.page,
          pageSize: this.pageSize,
          year: year
        }).then(res => {
           if (append) {
            this.showList = this.showList.concat(res.rows)
          } else {
            this.showList = res.rows
          }
          this.page++;
          if (res.total >= this.showList.length) {
            this.hasMore = false;
          } else {
            this.hasMore = true;
          }
        }, err => {
          console.log(err)
        }).catch(e => {})
      },
//      加载更多方法
      loadMore () {
        this.page++
        this.getList(true)
      }
    },
    components: {
      StickyBar
    },
    mounted () {
      let self = this;

      Bus.$bind('getList', function (year) {
        self.getList(year, false);
        self.year = year;
      })

      ScrollLoad.init(document.getElementById('scroller'),
                      this.$refs.loadTag,
                      function () {
                        if (!self.hasMore) {
                          return false;
                        }
                        this.getList(this.year, true);
                      },
                      this);
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';
  .news-list-ctner{
    min-height: 60vh;
  }
  .news-list{
    li{
      @include c-wrap();
      border-bottom: .02rem solid #f3f3f3;
      padding-top: .30rem;
      padding-bottom: .30rem;
    }
    .item-ctner{
      @include clear();
      padding-right: 3.05rem;
      h3{
        color: #3b3b3b;
        font-size: .34rem;
        line-height: 1.5em;
        font-weight: lighter;
        @include multi-els(2, 1.5em);
        margin-bottom: .32rem;
        height: 3em;
      }
      time{
        font-size: .24rem;
        color: #c6c6c6;
        float: left;
        padding-left: 1.5em;
        background: url('../assets/images/i-time.png') no-repeat;
        -webkit-background-size: 1em;
        background-size: 1em;
      }
      .item-cover{
        width: 2.54rem;
        height: 1.70rem;
        margin-right: -3.05rem;
        margin-top: -1.30rem;
        overflow: hidden;
        float: right;
        img{
          display: block;
          width: 100%;
        }
      }
    }
  }
  .more-news{
    display: block;
    width: 100%;
    text-align: center;
    background: #f3f3f3;
    border: 0;
    font-size: .26rem;
    color: #c5c5c5;
    line-height: .62rem;
    vertical-align: middle;
    .i-fresh{
      display: inline-block;
      width: .33rem;
      height: .33rem;
      position: relative;
      top: .05rem;
      margin-right: .28rem;
      background: url('../assets/images/i-more-g.png') no-repeat center center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/mobile/NewsList.vue